import { wellnessNestConfig } from "../configs/wellnessnest";
import { buildPilotSummary } from "./analytics";
import { startGemSales } from "./runtime";
import { EventPayload, GemSalesConfig, IntentProfile, PilotSummary } from "./types";
import { clearBufferedEvents, getBufferedEvents, getIntentProfile } from "./storage";
import { applyGemSalesScriptOptions, readGemSalesScriptOptions } from "./script-config";

const scriptOptions = readGemSalesScriptOptions();
const runtimeConfig = applyGemSalesScriptOptions(wellnessNestConfig, scriptOptions);

interface GemSalesGlobal {
  start: typeof startGemSales;
  wellnessNestConfig: GemSalesConfig;
  getEvents: () => EventPayload[];
  clearEvents: () => void;
  getIntentProfile: () => IntentProfile;
  getPilotSummary: () => PilotSummary;
  exportEvents: () => string;
}

declare global {
  interface Window {
    GemSales?: GemSalesGlobal;
    /** Legacy alias kept through the GemChat → GemSales rename. */
    GemChat?: GemSalesGlobal;
  }
}

window.GemSales = {
  start: startGemSales,
  wellnessNestConfig: runtimeConfig,
  getEvents: getBufferedEvents,
  clearEvents: clearBufferedEvents,
  getIntentProfile,
  getPilotSummary: () => buildPilotSummary(getBufferedEvents(), getIntentProfile()),
  exportEvents: () => JSON.stringify(getBufferedEvents(), null, 2),
};

if (scriptOptions.autostart) {
  startGemSales(runtimeConfig);
}

// Legacy global. Nothing has embedded the SDK yet, so this alias is cheap insurance rather than a
// compatibility burden — it costs one assignment and means an early integration written against the
// old name keeps working through the rename.
window.GemChat = window.GemSales;
